import angular from 'angular';
import { HelpersServiceModule } from '../helpers/helpers.service';

export const DiscountServiceModule = angular.module('acme.common.service.discount', [
  HelpersServiceModule
])
.service('DiscountService', [ 'HelpersService', function(HelpersService) {

    return {

      init: function() {
        return true;
      },

      applyDiscount: function(discount, price) {
        var total = 0;
        var round = 0;
        var discountValue = 0;
        var intPrice = HelpersService.currencyFloatToInteger(price);
        var value = parseFloat(discount.value);
        var intValue = HelpersService.currencyFloatToInteger(value);

        if (discount.discountType === 'PercentageBased') {
          discountValue = (intValue * intPrice) / 10000;
          round = (Number(String(discountValue).split('.')[1]) >= 5) ? 1 : 0;
          total = intPrice - (parseInt(String((intValue * intPrice) / 10000), 10) + round);
        }else if (discount.discountType === 'AmountBased') {
          total = intPrice - intValue;
        }

        if (total < 0) {
          total = 0;
        }

        console.log('DiscountService::applyDiscount', intPrice, intValue, round, discountValue, ((intValue * intPrice) / 10000));
        return HelpersService.integerToCurrencyFloat(total);
      },

      applyTotalDiscount: function(discount, quantity, price) {
        var total = 0,
            round = 0,
            discountValue = 0,
            intQuantity = parseInt(quantity, 10),
            value = parseFloat(discount.value),
            intValue = HelpersService.currencyFloatToInteger(value);

        if (discount.discountType === 'PercentageBased') {
          price = (price || 0);
          discountValue = (intValue) / 10000;
          total = (intQuantity * price * discountValue);
          total = HelpersService.currencyFloatToInteger(total);
        }else if (discount.discountType === 'AmountBased') {
          total = intValue;
        }

        if (total < 0) {
          total = 0;
        }

        console.log('DiscountService::applyDiscount', intQuantity, intValue, round, discountValue, ((intValue * intQuantity) / 10000));
        return HelpersService.integerToCurrencyFloat(total);

      }

    };

}]).name;